<template>
  <v-layout :column="$vuetify.breakpoint.xsOnly">
    <v-flex class="pr-30">
      <cover-field
        v-model="form.image"
        :upload-options="{path: `${eventId}/halls`}"
      />
    </v-flex>
    <v-flex>
      <text-field
        v-model.trim="form.name"
        autofocus
        :validator="vs.form.name"
        label="Hall name"
      />
      <div class="color-picker">
        <color-picker-field v-model="form.color" label="Hall color" />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'hall-form',
  props: {
    initialValues: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
    eventId: {
      default: null,
      type: String,
    },
  },
  data(){
    return {
      form: this.initialValues || { form: {}},
    }
  },
  watch: {
    form: {
      handler(val){
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>

</style>
